import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { ImageWithFallback, SidebarNavLink, SidebarWrapper } from '@components';
import { GlobalContext } from '@contexts';
import {
  ConnectorsIcon,
  NotificationsIcon,
  SettingsIcon,
  TeamsIcon,
  UserIcon,
  UsersIcon,
} from '@svgs';

const AccountSidebar = (props) => {
  const { t, i18n } = useTranslation();
  const globals = useContext(GlobalContext);

  return (
    <SidebarWrapper>
      <div className="sb-sidebar-nav">
        <ul className="sb-sidebar-el-user">
          <li className="sb-sidebar-nav-wicon">
            <span
              type="button"
              className="sb-user-settings-button sb-sidebar-nav-user-icon"
              aria-label="User Menu"
            >
              D
            </span>
            <div className="sb-sidebar-nav-wicon-content">
              <div className="sb-user-settings-info">
                <p className="sb-user-name">
                  {globals.user.first_name} {globals.user.last_name}
                </p>
                <p className="sb-user-email">{globals.user.email}</p>
              </div>
            </div>
          </li>
          <SidebarNavLink to={`/dashboard/settings/account`}>
            <UserIcon />
            Your account
          </SidebarNavLink>
          {/*
          <SidebarNavLink to={``}>
            <NotificationsIcon/>Notifications
          </SidebarNavLink>
          */}
        </ul>
        {globals.visible.usersView && (
          <ul className="sb-sidebar-el-account">
            <li className="sb-sidebar-nav-wicon">
              <span
                className="sb-user sb-flex"
                title="Back to Home"
                href="/dashboard/projects"
              >
                <ImageWithFallback
                  src={`https://img.logo.dev/${globals.whitelabel.whitelabel_domain}?token=pk_O2Nfflm4QRmgnwGsI12jUQ`}
                  fallbackSrc={`https://img.logo.dev/devhub.com?token=pk_O2Nfflm4QRmgnwGsI12jUQ`}
                  alt={globals.whitelabel.partner_name}
                />
              </span>
              <div className="sb-sidebar-nav-wicon-content">
                <p className="sb-user-name">
                  {globals.whitelabel.partner_name}
                </p>
              </div>
            </li>
            {globals.visible.usersView && (
              <SidebarNavLink to={`/dashboard/users`}>
                <UsersIcon />
                Users
              </SidebarNavLink>
            )}
            {globals.visible.groupsView && (
              <SidebarNavLink to={`/dashboard/groups`}>
                <UsersIcon />
                Groups
              </SidebarNavLink>
            )}
            {globals.visible.organizationView && (
              <SidebarNavLink to={`/dashboard/organization`}>
                <SettingsIcon />
                Settings
              </SidebarNavLink>
            )}
            {/**
            <SidebarNavLink to={``}>
              <TeamsIcon/>Teams
            </SidebarNavLink>
            <SidebarNavLink to={``}>
              <SettingsIcon/>Settings
            </SidebarNavLink>
            <SidebarNavLink to={``}>
              <ConnectorsIcon/>Connectors
            </SidebarNavLink>
            **/}
          </ul>
        )}
      </div>
    </SidebarWrapper>
  );
};

export default AccountSidebar;
